import { configureStore, combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';

import authReducer from './authSlice';
import config2Reducer, { updateCropsApiMiddleware } from './config/configSlice';
import objectsReducer from './config/objects';
import configReducer from './configSlice';
import inferenceReducer from './inference';
import activitiesReducer, { addActivityMiddleware } from './config/activities';
import paginationReducer from './pagination/paginationSlice';
import annotationReducer from './annotations/annotationSlice';
import preventNavigationReducer from './preventNavigation/preventNavigationSlice';
import configurationReducer from './configuration/configurationSlice';
import cameraLiveReducer from './config/cameraLive/cameraSlice';
import videoUploadReducer from './train/videoUploadTrackingSlice';
// Unique persist configurations per reducer
const configPersistConfig = { key: 'config', storage };
const config2PersistConfig = { key: 'configV2', storage };
const inferencePersistConfig = { key: 'inference', storage };
const paginationPersistConfig = { key: 'pagination', storage };
const annotationPersistConfig = { key: 'annotation', storage };
const configurationPersistConfig = { key: 'configuration', storage };
const cameraLivePersistConfig = { key: 'cameraLive', storage };

const rootReducer = combineReducers({
  auth: authReducer,
  config: persistReducer(configPersistConfig, configReducer),
  configV2: persistReducer(config2PersistConfig, config2Reducer),
  objects: objectsReducer,
  activities: activitiesReducer,
  inference: persistReducer(inferencePersistConfig, inferenceReducer),
  pagination: persistReducer(paginationPersistConfig, paginationReducer),
  annotation: persistReducer(annotationPersistConfig, annotationReducer),
  preventNavigation: preventNavigationReducer,
  videoUploadTracking: videoUploadReducer,
  configuration: persistReducer(
    configurationPersistConfig,
    configurationReducer
  ),
  cameraLive: persistReducer(cameraLivePersistConfig, cameraLiveReducer)
});

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE']
      }
    }).concat(updateCropsApiMiddleware, addActivityMiddleware)
});

const persistor = persistStore(store);

// Infer types
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export { store, persistor };
